/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Transition, Dialog } from "@headlessui/react";
import {
  Field,
  withDatasourceCheck,
  RichTextField,
  RichText,
} from "@sitecore-jss/sitecore-jss-nextjs";
import Pagination from "components/Shared/Pagination";
import { ComponentProps } from "lib/component-props";
import { useEffect, useMemo, useState, Fragment, useRef } from "react";
import Image from "next/image";
import moment from "moment";
import axios from "axios";
import { DGAButton } from "components/Shared/dga-button/DGAButton";
import { SpecificLoadingSpinner } from "components/Shared/specific-loading-spinner/SpecificLoadingSpinner";
import DGADropdownInput from "components/Shared/DGA-inputs/DGA-dropdown-input";
import { scrollToTopSafe } from "src/util/ScrollTopUsingGsap";
import { sanitizeYouTubeEmbedSrc } from "lib/UrlSanitization/YoutubeEmbedSanitization";

type PodcastsProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    title: Field<string>;
    description: RichTextField;
    buttonText: Field<string>;
  };
  locale: string;
  lang: string;
};

const Podcasts = (props: PodcastsProps): JSX.Element => {
  const [selectedSortOption, setSelectedSortOption] = useState<any>({
    id: 1,
    name: props?.fields?.buttonText?.value,
    sortValue: null,
    unavailable: false,
  });
  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const [videoURL, setVideoURL] = useState("");
  const safeVideoEmbedSrc = useMemo(() => sanitizeYouTubeEmbedSrc(videoURL), [videoURL]);
  const [listData, setListData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const container = useRef<HTMLDivElement | HTMLElement | any>();

  const sortItemsList = [
    {
      id: 1,
      name:
        props.locale === props?.lang
          ? props.locale === "ar"
            ? "الأحدث"
            : props.locale === "zh"
              ? "最新"
              : props.locale === "ko"
                ? "최신순"
                : "Newest"
          : "Newest",
      sortValue: true,
      unavailable: false,
    },
    {
      id: 2,
      name:
        props.locale === props?.lang
          ? props.locale === "ar"
            ? "الأقدم"
            : props.locale === "zh"
              ? "最旧"
              : props.locale === "ko"
                ? "오래된순"
                : "Oldest"
          : "Oldest",
      sortValue: false,
      unavailable: false,
    },
  ];
  const [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
    setVideoURL("");
  }

  function openModal(link: string) {
    setVideoURL(typeof link === "string" ? link : "");
    setIsOpen(true);
  }
  const getListData = async () => {
    setLoading(true);
    try {
      const res = await axios({
        url: `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/Podcast/GetPodcasts`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          culture: props?.locale,
          PageSize: currentPage - 1,
          PageNumber: itemsPerPage,
          order: selectedSortOption?.id == 1 ? "desc" : "asc",
          title: "",
        },
      });
      setListData(res.data);
      setError(false);
      setLoading(false); // Update listData with the response data
    } catch (error) {
      // Handle error
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    getListData();
  }, [selectedSortOption, currentPage, props.locale]);

  useEffect(() => {
    setSelectedSortOption({
      id: 1,
      name: props?.fields?.buttonText?.value,
      sortValue: null,
      unavailable: false,
    });
    setCurrentPage(1);
  }, [props.locale]);

  const onPageChange = (newPage: number) => {
    setLoading(true);
    scrollToTopSafe();
    setTimeout(() => {
      setCurrentPage(newPage);
    }, 250);
  };

  // if (loading) {
  //   return <SpecificLoadingSpinner />;
  // }

  if (error) {
    return <div className="min-h-screen">error</div>;
  }
  return (
    <>
      <div className="bg-primary-50 py-10">
        {props?.fields?.title?.value && (
          <h1 className="responsive font-bold text-3xl md:text-4xl md:font-semibold ">
            {props?.fields?.title?.value}
          </h1>
        )}
        {props?.fields?.description && (
          <div className={`responsive pt-4 text-base`}>
            <RichText field={props?.fields?.description} />
          </div>
        )}
        <div className="responsive mt-4">
          <div className="w-full flex justify-end">
            {!loading && listData?.PodcastData?.length > 0 && (
              <div className="self-start md:mt-0 mt-4">
                <div className=" relative z-20 min-w-[200px]  flex justify-end">
                  <DGADropdownInput
                    value={selectedSortOption?.id}
                    options={sortItemsList.map((item: any) => ({ ...item, label: item.name, value: item?.id }))}
                    maxHeight={300}
                    closeAfterSelect
                    onChange={(selected) => {
                      if (selected) {
                        const selectedSortItem = sortItemsList.find((item: any) => item?.id === selected);
                        setSelectedSortOption(selectedSortItem);
                      } else {
                        setSelectedSortOption({
                          id: 0,
                          name: props?.fields?.buttonText?.value,
                          sortValue: null,
                          unavailable: false,
                        });
                      }
                    }}
                    InputSize="lg"
                    name='publication-pages-sort-dropdown'
                    variant='default'
                    placeholder={selectedSortOption
                      ? selectedSortOption.name
                      : props?.fields?.buttonText?.value}
                    mainDropdownContainerClassName='max-w-[121px] md:max-w-[250px] w-full'
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        ref={container}
        className={` responsive py-10 ${props?.locale == props?.lang ? "rtl" : ""}`}
      >
        {!loading && !error && listData?.PodcastData?.length <= 0 && (
          <div>
            <p className="text-[#142836] text-base md:text-lg lg:text-xl font-normal">
              {props?.locale == props?.lang ? "قريبا" : "Coming Soon"}
            </p>
          </div>
        )}
        {loading && <SpecificLoadingSpinner />}
        <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 overflow-hidden">
          {!loading &&
            listData?.PodcastData?.length > 0 &&
            listData?.PodcastData?.map((item: any, index: number) => {
              return (
                <div
                  className=" animate-top-dga p-4 rounded-2xl border border-neutral-300 flex justify-between flex-col gap-8"
                  key={index}
                >
                  <div className="flex flex-col gap-8 h-full">
                    <div className="relative h-[160px] md:h-[250px] w-full bg-neutral-50">
                      {item?.Image && (
                        <Image
                          src={
                            item?.Image
                              ? process.env.NEXT_PUBLIC_SITECORE_API_HOST + item?.Image
                              : "/event-placeholder.jpg"
                          }
                          alt={item?.Title || item?.Description || `Podcast thumbnail ${index + 1}`}
                          layout="fill"
                          objectFit="cover"
                          objectPosition="center"
                          className="rounded-lg"
                        />
                      )}
                    </div>

                    <div className="flex flex-col gap-2 flex-1">
                      <h2 className="text-lg font-bold">{item?.Title}</h2>
                      <p className="text-base line-clamp-4 mt-auto">{item?.SubTitle} </p>
                    </div>
                  </div>
                  <div className="">
                    <div className="flex justify-between items-center">
                      {item?.date && (
                        <span className="p-2 py-[3px] border border-neutral-300 text-xs font-medium bg-neutral-100 rounded">
                          {moment(item?.date).locale(props?.locale).format("DD MMMM YYYY")}{" "}
                        </span>
                      )}

                      <DGAButton
                        size="iconOnly md"
                        variant="secondarySolid"
                        onClick={() => {
                          if (item?.VideoID) openModal(item?.VideoID);
                        }}
                        disabled={!item?.VideoID}
                        aria-label={`Play video: ${item?.Title || "podcast"}`}
                        buttonContent={
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.5886 9.03673L13.507 8.98624C12.8503 8.57997 12.2993 8.23909 11.8422 8.02739C11.3786 7.81269 10.85 7.65067 10.2988 7.82076C9.93447 7.93318 9.6108 8.14417 9.35518 8.42499C8.98329 8.83355 8.86071 9.36753 8.80525 9.90122C8.74997 10.4331 8.74998 11.1202 8.75 11.9569V12.0429C8.74998 12.8796 8.74997 13.5667 8.80525 14.0986C8.86071 14.6323 8.98329 15.1662 9.35518 15.5748C9.6108 15.8556 9.93447 16.0666 10.2988 16.179C10.85 16.3491 11.3786 16.1871 11.8422 15.9724C12.2993 15.7607 12.8503 15.4198 13.507 15.0135L13.5886 14.9631C14.2703 14.5414 14.8387 14.1898 15.2505 13.8622C15.6745 13.525 16.0479 13.1264 16.1821 12.5709C16.2726 12.1964 16.2726 11.8034 16.1821 11.4289C16.0479 10.8734 15.6745 10.4748 15.2505 10.1376C14.8387 9.81 14.2703 9.45843 13.5886 9.03673ZM10.4645 9.4347C10.5477 9.34324 10.6442 9.28396 10.7411 9.25408C10.7497 9.25136 10.8484 9.2202 11.2118 9.38849C11.5766 9.55745 12.0502 9.84885 12.7593 10.2875C13.4916 10.7405 13.9829 11.0459 14.3168 11.3115C14.6466 11.5738 14.7069 11.7101 14.7241 11.7813C14.7586 11.9242 14.7586 12.0756 14.7241 12.2185C14.7069 12.2897 14.6466 12.4259 14.3168 12.6883C13.9829 12.9539 13.4916 13.2592 12.7593 13.7122C12.0502 14.1509 11.5766 14.4423 11.2118 14.6113C10.8484 14.7796 10.7497 14.7484 10.7411 14.7457C10.6442 14.7158 10.5477 14.6565 10.4645 14.5651C10.4265 14.5234 10.3442 14.3956 10.2972 13.9435C10.251 13.4986 10.25 12.8902 10.25 11.9999C10.25 11.1095 10.251 10.5012 10.2972 10.0563C10.3442 9.60414 10.4265 9.47636 10.4645 9.4347Z"
                              fill="currentColor"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
                              fill="currentColor"
                            />
                          </svg>
                        }
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-50" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 "
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0 "
                >
                  <Dialog.Panel className="aspectRationdiv  transform overflow-hidden  bg-white   text-left align-middle  transition-all">
                    {safeVideoEmbedSrc ? (
                      <iframe
                        title="Embedded video player"
                        width="100%"
                        height="100%"
                        // sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"
                        sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
                        src={safeVideoEmbedSrc}
                      />
                    ) : (
                      <div className="flex min-h-[240px] w-full items-center justify-center p-6 text-center text-sm text-neutral-800">
                        {props?.locale === props?.lang ? "تعذر تحميل الفيديو" : "Video could not be loaded"}
                      </div>
                    )}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
      <div className="responsive border-4 border-white flex justify-end w-full">
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalItems={listData?.TotalItemsCount} // Replace with your total items count
          itemsPerPage={itemsPerPage} // Replace with your items per page count
          onPageChange={onPageChange}
          maxPages={5} // Maximum number of pages to display in pagination
          locale={props?.locale}
          lang={props?.lang}
          scrollToRef={null}
        />
      </div>
    </>
  );
};

export default withDatasourceCheck()<PodcastsProps>(Podcasts);
